import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../errors/api-error-handler";
import {
  TaxonomyInitialStateType,
  TaxonomyType,
} from "../../models/taxonomy-model";
import TaxonomyProductService from "../../services/taxonomy-product.service";

const initialState: TaxonomyInitialStateType = {
  data: [],
  loading: true,
  error: undefined,
};

export const retrieveTaxonomyProduct = createAsyncThunk(
  "taxonomyProduct/retrieve",
  async (productPath: string) => {
    const response = await TaxonomyProductService.getTaxonomyProductList(productPath);
    return [...response.data.result];
  }
);

const taxonomyProductSlice = createSlice({
  name: "taxonomyProduct",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveTaxonomyProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(retrieveTaxonomyProduct.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.data = action.payload as TaxonomyType[];
        }
      })
      .addCase(retrieveTaxonomyProduct.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default taxonomyProductSlice.reducer;
